import { createStore, createHook } from "react-sweet-state";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    isLoading: false,
    leftMenu:true
  },
  // actions that trigger store mutation
  actions: {
    changeMode:
      (e) =>
      async ({ setState, getState }) => {
        setState({ mode: !this.initialState.leftMenu});

      },
  },
  // optional, mostly used for easy debugging
  name: "listOfAdministrator",
});

export const usePageSettingStore = createHook(Store);
